export default "__VITE_ASSET__AC_3Bmxo__"